import { CommonModule } from '@angular/common'
import { Component, computed, input } from '@angular/core'

import { ImageModule } from 'primeng/image'

import {
  FileExtension,
  FileMimeType,
  imageFileTypes,
} from '@flowx/designer/modules/ai/types/ai.types'
import { convertBlobToBase64 } from '@flowx/designer/shared/utils/file.utils'

@Component({
  selector: 'flx-ai-msg-file-preview',
  imports: [CommonModule, ImageModule],
  templateUrl: './ai-msg-file-preview.component.html',
  styleUrl: './ai-msg-file-preview.component.scss',
})
export class AiMsgFilePreviewComponent {
  files = input([])

  images = computed(() => {
    const files = this.files()

    return (
      files
        ?.filter((file) => imageFileTypes.includes(file.type as FileMimeType))
        .map((image) => ({
          name: image.name,
          src$: convertBlobToBase64(image),
        })) ?? []
    )
  })

  bpmnFiles = computed(() => {
    const files = this.files()

    return (
      files
        ?.filter((file) => file.name.endsWith(FileExtension.BPMN))
        .map((file) => ({
          name: file.name,
          src$: convertBlobToBase64(file),
        })) ?? []
    )
  })
}
